import sizeof from 'object-sizeof';

export const getJsonMemorySize = (obj: any): number => {
  return sizeof(obj);
};
